// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../../Api";
import ResponseChecker from "../../Middlewares/ResponseChecker";
import { defaultMessages } from "../../enums/responseMessages.js";

import Endpoints from "../../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## MobileApp.Deeplink Get
/**
 *
 * @param {{params: object, query: { paymentMethodId: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.MobileApp.Deeplink.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## MobileApp.Deeplink Create
/**
 *
 * @param {{ paymentMethodId: string, MobileApp.DeeplinkRate: number }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.MobileApp.Deeplink.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.Deeplink Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.MobileApp.Deeplink.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.Deeplink Update
/**
 *
 * @param {{ paymentMethodId: string, MobileApp.DeeplinkRate: number, isActive: boolean }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.MobileApp.Deeplink.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.Deeplink Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(
    Endpoints.MobileApp.Deeplink.Delete(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
